"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectPresenterSources = exports.selectMediaSources = exports.selectLastPresenterSource = exports.selectLastMediaSource = exports.selectBroadcastSources = void 0;
var _Sources = require("@studio/constants/Sources");
var _reselect = require("reselect");
var _underscore = require("underscore");
var _sources = require("../utils/sources");
var selectBroadcastSources = exports.selectBroadcastSources = (0, _reselect.createSelector)(function (state) {
  return state.broadcastSources['sources'] || [];
}, function (sources) {
  return sources;
});
var selectPresenterSources = exports.selectPresenterSources = (0, _reselect.createSelector)(selectBroadcastSources, function (sources) {
  return sources.filter(function (source) {
    return source.type === _Sources.CAMERA_PRESENTER;
  });
});
var selectLastPresenterSource = exports.selectLastPresenterSource = (0, _reselect.createSelector)(selectPresenterSources, function (sources) {
  var lastCameraSource = (0, _underscore.last)((0, _sources.orderSources)(sources));
  return !(0, _underscore.isEmpty)(lastCameraSource) ? lastCameraSource : {};
});
var selectMediaSources = exports.selectMediaSources = (0, _reselect.createSelector)(selectBroadcastSources, function (sources) {
  return sources.filter(function (source) {
    return [_Sources.IMAGE_FILE, _Sources.VIDEO_FILE, _Sources.AUDIO_FILE, _Sources.PDF_FILE].includes(source.type);
  });
});
var selectLastMediaSource = exports.selectLastMediaSource = (0, _reselect.createSelector)(selectMediaSources, function (sources) {
  var lastMediaSource = (0, _underscore.last)((0, _sources.orderSources)(sources));
  return !(0, _underscore.isEmpty)(lastMediaSource) ? lastMediaSource : {};
});